import React from 'react'

import { blue } from 'src/components/__legacy__/color/palette'
import { Logline } from 'src/components/__legacy__/icon/monochrome'
import { Modal } from 'src/components/__legacy__/modal/modal'
import { ModalContent } from 'src/components/__legacy__/modal/modal-content'
import { ModalTitle } from 'src/components/__legacy__/modal/modal-title'
import { Spacer } from 'src/components/__legacy__/spacer/spacer'
import {
  Table,
  TableBody,
  TableBodyCell,
  TableHead,
  TableHeadCell,
  TableRow,
} from 'src/components/__legacy__/table/table'
import styled from 'styled-components'
import Flex from 'styled-flex-component'

import { useTemplateEntities } from '../../../../template-entities-context'

type Props = {
  onClose: () => void
  templateUid: string
}

export const FolderMapModal: React.FC<Props> = props => {
  const { getTemplate } = useTemplateEntities()
  const template = getTemplate(props.templateUid)
  const heads = ['タイトル', 'セクション', 'EDCフォルダ名']

  return (
    <Modal onClose={props.onClose} size="L">
      <ModalTitle title="セクション×EDCフォルダ名" />

      <ModalContent>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {heads.map(head => (
                  <TableHeadCell key={head}>{head}</TableHeadCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {template &&
                template.mediumItems &&
                template.mediumItems.map(mediumItem => (
                  <TableRow borderBottom key={template.uid}>
                    <TableBodyCell>{template.title}</TableBodyCell>
                    <TableBodyCell>
                      <Flex alignCenter>
                        <div>{mediumItem.title}</div>
                        <Spacer size={10} horizontal />
                        {mediumItem.isLogline && <Logline color={blue[70]} />}
                      </Flex>
                    </TableBodyCell>
                    <TableBodyCell>{mediumItem.folderName}</TableBodyCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </ModalContent>
    </Modal>
  )
}

const TableContainer = styled.div`
  width: 100%;
  height: 300px;
`
